module.exports = __webpack_public_path__ + "static/img/cont54 (4).8028a04.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont54 (4).jpg
// module id = Eaxb
// module chunks = 0